import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function Settings() {
  const { user, refreshMe } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [logo, setLogo] = useState(user?.brand_logo || "");
  const [bio, setBio] = useState(user?.host_bio || "");
  const [saving, setSaving] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.patch("/auth/profile", { name, brand_logo: logo || null, host_bio: bio || null });
      toast.success("Profile updated");
      refreshMe();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally { setSaving(false); }
  };

  return (
    <div className="space-y-6 vp-fade-up max-w-2xl">
      <div>
        <div className="vp-label">Settings</div>
        <h1 className="font-display text-3xl font-bold mt-1">Creator profile</h1>
      </div>
      <form onSubmit={save} className="vp-glass p-6 space-y-5">
        <div>
          <div className="vp-label mb-2">Full name</div>
          <input className="vp-input" value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <div>
          <div className="vp-label mb-2">Brand logo URL</div>
          <input className="vp-input" value={logo} onChange={(e) => setLogo(e.target.value)} placeholder="https://…" />
        </div>
        <div>
          <div className="vp-label mb-2">Host bio</div>
          <textarea rows={4} className="vp-input" value={bio} onChange={(e) => setBio(e.target.value)} placeholder="Two-line bio for your landing page" />
        </div>
        <button disabled={saving} className="vp-btn-primary">{saving ? "Saving…" : "Save profile"}</button>
      </form>
    </div>
  );
}
